import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import * as fromRouter from '../module-router-selectors';
import { ModuleRouterUtils } from '../../utils/module-router/module-router.utils';

@Injectable()
export class ModuleRouterFacade {
  readonly #store = inject(Store);
  readonly #redirectService = new ModuleRouterUtils();

  readonly url = this.#store.selectSignal(fromRouter.selectUrl);

  readonly module = this.#store.selectSignal(fromRouter.selectModule);

  readonly submodule = this.#store.selectSignal(fromRouter.selectSubmodule);

  readonly detailId = this.#store.selectSignal(fromRouter.selectDetailId);

  readonly data$ = this.#store.select(fromRouter.selectData);

  publicModuleRoutePath(options?: { module?: string }): string {
    const module = options?.module ?? this.module();

    return this.#redirectService.publicModulePath(module);
  }

  publicSubmoduleRoutePath(options?: { module?: string; submodule?: string }): string {
    const module = options?.module ?? this.module();
    const submodule = options?.submodule ?? this.submodule();

    return this.#redirectService.publicSubmodulePath(module, submodule);
  }

  publicDetailRoutePath(options?: { module?: string; submodule?: string; detailId?: string }): string {
    const module = options?.module ?? this.module();
    const submodule = options?.submodule ?? this.submodule();
    const detailId = options?.detailId ?? this.detailId();

    return this.#redirectService.publicDetailPath(module, submodule, detailId);
  }
}
